module.exports = __webpack_public_path__ + "area_guangdong.20d3c48d.png";